<app-grid-page>
  <!-- Title -->
  <div class="title-selector g-margin-right-12">{{texts.settings.env_config.pcap_player.title}}</div>
  <!-- Search -->
    <app-ui-search #searchComponent></app-ui-search>
  <!-- Buttons -->
  <app-pcap-player-grid-buttons class="btns-selector"
                                (uploadFile)="uploadPcapFile($event)"
                                [isRunning]="actionsStatus$ | async"
                                [focusedRow]="focusedRow">
  </app-pcap-player-grid-buttons>
  <!-- Grid -->
  <app-generic-basic-grid class="g-grid-content grid-selector"
                          [searchBar]="searchComponent"
                          [rowData]="pcapFiles$"
                          [gridSettings]="gridSettings"
                          [listenToDeactivate]="onDeactivate.asObservable()"
                          [exportCsv]="exportCsv$"
                          (focusedRowChange)="onFocusChanged($event)">
  </app-generic-basic-grid>
</app-grid-page>
